export const API = {
  __REST_API_URL: "https://api.fouassin-gmao.fr/prefecture",
  __SOCKET_URL: "https://api.fouassin-gmao.fr",
  __SOCKET_PATH: "/prefecture/socket.io",
};



// WEBPACK FOOTER //
// ./src/config/Api.ts